import { autoinject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { Zone } from "../../../models/zone";
import { LeafletMap } from "../../../mapping/leaflet-map"
import * as L from 'leaflet';
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Device } from "../../../models/device";
import { AsEnumerable } from "linq-es2015/lib/linq";
import { Subscription } from "rxjs";
@autoinject
export class MapZone {
	zone: Zone;
	map: LeafletMap;
	mapHeight: number = 600;
	mapId: string = "device-map";
	eventAggregator: EventAggregator;
	subscription: any;
	deviceSubscription: Subscription;
	device: any;
	protected applicationState: IState;
	protected store: Store<IState>;
	private markers: Map<string, L.Marker> = new Map<string, L.Marker>();

	constructor(store: Store<IState>, eventAggregator: EventAggregator) {
		this.eventAggregator = eventAggregator;
		this.store = store;
	}

	bind(bindingContext: any, overrideContext: any) {
		this.zone = bindingContext.zone;
	}

	attached() {

		// Leaflet will not properly draw it's tiles until the container
		// it's hosted in has it's width set.  Since we nest zones
		// in a  collapsible we need to have the map redraw itself when 
		// the collapsible is opened.
		this.subscription = this.eventAggregator.subscribe("ZoneOpened",
			message => {
				this.map.invalidateSize();
			});


		this.deviceSubscription = this.store.state.subscribe((state) => {
			this.applicationState = state;
			if (this.device) {
				this.device = this.getDevice();
				if (this.device) {
					//this.setChecked((this.device.data.valveIsOpen));
				}
			}
		});
		//this.device = bindingContext.device;
		const mapConfig = {
			//40.340043, -76.732476
			//47.198027, -121.006375
			//location: { "lat": 44.1505846, "lng": -121.2868672 }, // bend
			//location: { "lat": 45.1240334, "lng":-123.1336176 }, //farm
			//location: { "lat": 47.198027, "lng": -121.006375 },

			//location: { "lat": 40.340043, "lng": -76.732476 }, //harrisburg
            location: JSON.parse(this.zone.gpsCoordinates),
			zoom: 19,
			minZoom: 1
		};

		this.map = new LeafletMap(this.mapId, mapConfig, "Satellite");
		this.map.showZoomControl();
		this.map.addLayerGroup("Devices");
		this.map.showLayerControl();
		this.renderDevices();
		
	}

	unbind() {
		//this.subscription.unsubscribe();

		if (this.subscription) {
			this.subscription.dispose();
		}
		if (this.deviceSubscription) {
			this.deviceSubscription.unsubscribe()
		}
	
	}

	getDevice(): Device {

		const deviceMetadata = this.device.metadata;
		if (deviceMetadata) {
			const location = AsEnumerable(this.applicationState.locationState.selectedLocations)
				.FirstOrDefault(location => location.id === deviceMetadata.locationId);

			if (location == null) {
				return null;
			}

			const zone = AsEnumerable(location.zones).FirstOrDefault(zone => zone.id === deviceMetadata.zoneId);
			if (zone == null) {
				return null;
			}

			const structure = AsEnumerable(zone.structures)
				.FirstOrDefault(structure => structure.id === deviceMetadata.structureId);
			if (structure == null) {
				return null;
			}
			const devices = AsEnumerable(structure.devices);
			return devices.FirstOrDefault((device: Device) => device.deviceId === deviceMetadata.deviceId);
		}
		return null;
	}

	clearDeviceMarkers() {
		this.markers.forEach((value: boolean, key: string) => {
			console.log(key, value);
			this.map.removeMarker(value);
		});
        this.markers.clear();
	}

	renderDevices() {
		this.clearDeviceMarkers();
		for (let structure of this.zone.structures) {
			for (let device of structure.devices) {
				//{"type":"position","latitudeDeg":44.1505959,"longitudeDeg":-121.2867375,"inTrip":false,"fixFailed":false,"headingDeg":264.375,"speedKmph":1,"battery":4800,"manDown":false,"timestamp":"2019-07-09T04:02:10","rssi":-115}

				if (device.data) {
					const data = device.data;
                    const marker = this.map.addMarker({ "lat": data.latitudeDeg, "lng": data.longitudeDeg },
						device.deviceId,
						`<b>${structure.name}</b><br/>${data.latitudeDeg}<br/>${data.longitudeDeg}<br/>${data.timestamp
						}`,
						"Devices");
                    this.markers.set(device.deviceId, marker);
				}
			}
		}
	}
}
